import moment from "moment/moment";

function timeToLocal(timestamp, format = 'HH:mm DD/MM/YY') {
    const serverDate = this.moment.tz(timestamp, 'Europe/Berlin');
    const userTimeZone = this.moment.tz.guess(true);

    if (userTimeZone) {
        return serverDate.tz(userTimeZone).format(format);
    }

    return serverDate.format(format);
}


function convertLocalTimeToBerlinTime(time, format = 'HH:mm') {
    const currentStartTime = moment(time, format);
    return currentStartTime.tz('Europe/Berlin');
}

export default {
    data() {
        return {
            moment: moment
        }
    },
    methods: {
        timeToLocal,
        convertLocalTimeToBerlinTime,
    }
}
